<template>
    <body :class="{'menu-is-open':menu_isOpen}">
    <div id="app" class="mega-main">
        <router-view/>
        <div class="loading" v-if="loading"><img src="./assets/svg/loader.svg" height="40"></div>
        <notifications :duration=6000>
            <template slot="body" slot-scope="props">
                <div class="alert" :class="props.item.type" @click="props.close">
                    <h3 v-if="props.item.title" v-html="props.item.title"></h3>
                    <h5 v-if="props.item.text" v-html="props.item.text"></h5>
                </div>
            </template>
        </notifications>
        <cookie-law theme="cookie-tds">
            <div slot-scope="props">
                <!--<img src="./assets/svg/cookie-icon.svg" height="40">-->
                <div v-html="$t('cookie.text')"></div>
                <!--<router-link :to="$i18nRoute({name:'privacy-policy'})">{{$t('cookie.link')}}</router-link>-->
                <button class="Cookie__button" @click="props.accept"><span>{{$t('cookie.accept_btn')}}</span></button>
            </div>
        </cookie-law>
    </div>
    </body>
</template>


<script>
    import CookieLaw from 'vue-cookie-law'
    export default {
        name: 'App',
        components: {CookieLaw},
        computed: {
            loading() {
                return this.$store.getters.loading
            },menu_isOpen() {
                return this.$store.getters.menu_open
            }
        }
    }
</script>
<style>
    .slide-fade-enter-active {
        transition: all 1.5s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
    }

    /* Absolute Center Spinner */
    .loading {
        position: fixed;
        z-index: 99999;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(255, 255, 255, 0.6);
        -webkit-backdrop-filter: saturate(180%) blur(20px);
        backdrop-filter: saturate(180%) blur(20px);
    }

    /* Transparent Overlay */
    /*.loading:before {*/
    /*content: '';*/
    /*display: block;*/
    /*position: fixed;*/
    /*top: 0;*/
    /*left: 0;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*background: red;*/
    /*transition: 4s all;*/
    /*!*background: radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0, .8));*!*/

    /*!*background: -webkit-radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0,.8));*!*/
    /*}*/
</style>
